import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

type LabelTypes = {
  checked?: boolean;
};

export const HiddenInput = styled.input`
  display: none;
`;

export const Label = styled.label<LabelTypes>`
  border: 2px solid ${({ checked }): string => (checked ? tokens.colors.primary : tokens.colors.gray)};
  margin: 0;
  box-sizing: content-box;
  cursor: pointer;

  max-width: 347px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  padding: ${tokens.space.larger} ${tokens.space.larger} ${tokens.space.larger} ${tokens.space.large};
  text-align: left;
  box-sizing: border-box;
  border-radius: ${tokens.radii.m};

  &.checked {
    border: 2px solid ${tokens.colors.primary};
    padding: ${tokens.space.large} ${tokens.space.large} 33px;
  }
`;
